// VendorProductList.jsx
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TablePagination,
  Stack,
  useMediaQuery,
  Switch,
  FormControlLabel,
  Checkbox,
  Card,
  CardContent,
  Grid,
  Chip,
  InputAdornment
} from "@mui/material";

import UploadFileIcon from "@mui/icons-material/UploadFile";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InventoryIcon from "@mui/icons-material/Inventory";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import api from "../../api/axios";

function MobileProductCard({ product, onEdit, onDelete, onView, onToggleFeatured }) {
  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: 2,
        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
      }}
    >
      <Typography fontWeight={600}>{product.title}</Typography>

      <Typography variant="body2" color="text.secondary">
        {product.category?.name||'-'}
      </Typography>

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mt: 1 }}
      >
        <Typography fontWeight={600}>₹{Number(product.price || 0).toLocaleString("en-IN")}</Typography>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="body2">
            Stock: {product.stock ?? "-"}
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={product.isFeatured || false}
                onChange={() => onToggleFeatured && onToggleFeatured(product._id, !product.isFeatured)}
                size="small"
                color="primary"
              />
            }
            label="Featured"
            labelPlacement="start"
            sx={{ m: 0 }}
          />
        </Stack>
      </Stack>

      <Typography
        variant="caption"
        sx={{
          display: "inline-block",
          mt: 1,
          px: 1,
          py: 0.3,
          borderRadius: 1,
          bgcolor:
            product.status === "published"
              ? "rgba(46,125,50,0.1)"
              : "rgba(237,108,2,0.1)",
          color:
            product.status === "published"
              ? "green"
              : "orange",
        }}
      >
        {product.status}
      </Typography>

      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        {/* <Button
          size="small"
          startIcon={<VisibilityIcon />}
          onClick={onView}
        >
          View
        </Button> */}

        <Button
          size="small"
          startIcon={<EditIcon />}
          sx={{ color: "#ff9900" }}
          onClick={onEdit}
        >
          Edit
        </Button>

        <Button
          size="small"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={onDelete}
        >
          Delete
        </Button>
        <Tooltip
  title={
    product?.status === "published"
      ? "Unlist (Hide from customers)"
      : "Publish (Make visible to customers)"
  }
>
  <IconButton
    size="small"
    onClick={async () => {
      await api.patch(`/products/${product._id}/toggle-visibility`);

      window.location.reload(); // simplest safe fix for mobile
    }}
    sx={{
      color:
        product?.status === "published"
          ? "orange"
          : "green",
    }}
  >
    {product?.status === "published" ? (
      <VisibilityOffIcon />
    ) : (
      <CheckCircleIcon />
    )}
  </IconButton>
</Tooltip>
      </Stack>
    </Paper>
  );
}


export default function VendorProductList() {
  const navigate = useNavigate();

  const [products, setProducts] = useState([]); // ✅ FIX
  const [search, setSearch] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");

  // Table header filters
  const [stockFilter, setStockFilter] = useState("all"); // all, low, out, sufficient
  const [statusFilter, setStatusFilter] = useState("all"); // all, published, unlisted, draft
  const [featuredFilter, setFeaturedFilter] = useState("all"); // all, featured, not-featured

  // Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Delete dialog
  const [deleteId, setDeleteId] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);

  // Inventory management
  const [editingStockId, setEditingStockId] = useState(null);
  const [editingStockValue, setEditingStockValue] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [bulkStockValue, setBulkStockValue] = useState("");
  const [inventorySummary, setInventorySummary] = useState({
    totalProducts: 0,
    totalStock: 0,
    lowStockCount: 0,
    outOfStockCount: 0,
  });

    const [searchParams] = useSearchParams();
  const initialType = searchParams.get("type") || "all";
  const filterParam = searchParams.get("filter");

  const [type, setType] = useState(initialType);
  
  // Apply filter from URL parameter
  useEffect(() => {
    if (filterParam === "low+out") {
      // Apply both low stock and out of stock filter
      // Since we can only apply one stock filter at a time, we'll create a custom filter
      // We'll set a special state to handle combined filter
      setStockFilter("low+out");
    }
  }, [filterParam]);
  /* ======================
     FETCH VENDOR PRODUCTS
     ====================== */
useEffect(() => {
  const fetchProducts = async () => {
    try {
      const res = await api.get(`/products?type=${type}&vendor=true`);
      console.log('Fetched products:', res.data.products);
      setProducts(res.data.products || []);
    } catch (err) {
      console.error("Fetch products failed", err);
    }
  };

  fetchProducts();
}, [type]); // 🔥 THIS is the fix

  /* ======================
     DYNAMIC CATEGORY LIST
     ====================== */
  const CATEGORY_LIST = [
  ...new Map(
    products
      .filter((p) => p.category)
      .map((p) => [p.category._id, p.category])
  ).values(),
];

  /* ======================
     FILTERING
     ====================== */
  const filtered = products.filter((p) => {
    const matchesSearch = p.title
      ?.toLowerCase()
      .includes(search.toLowerCase());

    const matchesCategory = categoryFilter
  ? p.category?._id === categoryFilter
  : true;

    // Stock filter
    const matchesStock = (() => {
      const stock = p.stock || 0;
      switch (stockFilter) {
        case "low": return stock > 0 && stock <= 10;
        case "out": return stock === 0;
        case "sufficient": return stock > 10;
        case "low+out": return (stock > 0 && stock <= 10) || stock === 0;
        case "all":
        default: return true;
      }
    })();

    // Status filter
    const matchesStatus = statusFilter === "all" || p.status === statusFilter;

    // Featured filter
    const matchesFeatured = (() => {
      switch (featuredFilter) {
        case "featured": return p.isFeatured === true;
        case "not-featured": return p.isFeatured === false;
        case "all":
        default: return true;
      }
    })();

    return matchesSearch && matchesCategory && matchesStock && matchesStatus && matchesFeatured;
  });

  const isMobile = useMediaQuery("(max-width:900px)");


  /* ======================
     PAGINATION
     ====================== */
  const paginated = filtered.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  /* ======================
     BULK EXCEL UPLOAD (LOCAL PREVIEW ONLY)
     ====================== */
  const handleBulkUpload = async (file) => {
    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(worksheet);

      const mapped = json.map((r, i) => ({
        _id: `bulk-${Date.now()}-${i}`,
        title: r.title || r.Title || `Untitled ${i + 1}`,
        category: r.category || r.Category || "Uncategorized",
        price: Number(r.price || r.Price || 0),
        stock: Number(r.stock || r.Stock || 0),
        status: "draft",
      }));

      setProducts((prev) => [...mapped, ...prev]);
      alert(`Imported ${mapped.length} products (preview only)`);
    } catch {
      alert("Failed to import Excel file");
    }
  };

  /* ======================
     TOGGLE FEATURED STATUS
     ====================== */
  const handleToggleFeatured = async (productId, newFeaturedStatus) => {
    try {
      await api.patch(`/products/${productId}`, {
        isFeatured: newFeaturedStatus
      });
      
      // Update local state
      setProducts((prev) =>
        prev.map((p) =>
          p._id === productId
            ? {
                ...p,
                isFeatured: newFeaturedStatus,
                featuredAt: newFeaturedStatus ? new Date() : null
              }
            : p
        )
      );
    } catch (error) {
      console.error("Failed to update featured status:", error);
      alert("Failed to update featured status");
    }
  };

  /* ======================
     DELETE PRODUCT
     ====================== */
  const confirmDelete = async () => {
    try {
      await api.delete(`/products/${deleteId}`);
      setProducts((prev) => prev.filter((p) => p._id !== deleteId));
    } catch {
      alert("Failed to delete product");
    } finally {
      setDeleteOpen(false);
      setDeleteId(null);
    }
  };

  /* ======================
     INVENTORY MANAGEMENT FUNCTIONS
     ====================== */
  // Start inline stock editing
  const startEditStock = (productId, currentStock) => {
    setEditingStockId(productId);
    setEditingStockValue(currentStock?.toString() || "");
  };

  // Save stock edit
  const saveStockEdit = async () => {
    if (!editingStockId || editingStockValue === "") return;

    try {
      const stockNum = parseInt(editingStockValue, 10);
      if (isNaN(stockNum) || stockNum < 0) {
        alert("Please enter a valid non-negative number");
        return;
      }

      await api.patch(`/products/${editingStockId}`, {
        stock: stockNum
      });

      // Update local state
      setProducts((prev) =>
        prev.map((p) =>
          p._id === editingStockId
            ? { ...p, stock: stockNum }
            : p
        )
      );

      setEditingStockId(null);
      setEditingStockValue("");
      alert("Stock updated successfully");
    } catch (error) {
      console.error("Failed to update stock:", error);
      alert("Failed to update stock");
    }
  };

  // Cancel stock edit
  const cancelStockEdit = () => {
    setEditingStockId(null);
    setEditingStockValue("");
  };

  // Toggle product selection for bulk operations
  const toggleProductSelection = (productId) => {
    setSelectedProducts((prev) =>
      prev.includes(productId)
        ? prev.filter((id) => id !== productId)
        : [...prev, productId]
    );
  };

  // Select all products
  const selectAllProducts = () => {
    if (selectedProducts.length === filtered.length) {
      setSelectedProducts([]);
    } else {
      setSelectedProducts(filtered.map((p) => p._id));
    }
  };

  // Bulk stock update
  const handleBulkStockUpdate = async () => {
    if (!bulkStockValue || selectedProducts.length === 0) {
      alert("Please select products and enter a stock value");
      return;
    }

    const stockNum = parseInt(bulkStockValue, 10);
    if (isNaN(stockNum) || stockNum < 0) {
      alert("Please enter a valid non-negative number");
      return;
    }

    try {
      const updates = selectedProducts.map((productId) => ({
        productId,
        stock: stockNum
      }));

      await api.post("/products/bulk-stock-update", { updates });

      // Update local state
      setProducts((prev) =>
        prev.map((p) =>
          selectedProducts.includes(p._id)
            ? { ...p, stock: stockNum }
            : p
        )
      );

      setBulkStockValue("");
      setSelectedProducts([]);
      alert(`Stock updated for ${selectedProducts.length} product(s)`);
    } catch (error) {
      console.error("Bulk stock update failed:", error);
      alert("Failed to update stock for selected products");
    }
  };

  // Calculate inventory summary
  const calculateInventorySummary = () => {
    // Only count published products for inventory summary
    const publishedProducts = products.filter(p => p.status === "published");
    const totalProducts = publishedProducts.length;
    const totalStock = publishedProducts.reduce((sum, p) => {
      const stock = Number(p.stock) || 0;
      return sum + stock;
    }, 0);
    const lowStockCount = publishedProducts.filter((p) => {
      const stock = Number(p.stock) || 0;
      return stock > 0 && stock <= 10;
    }).length;
    const outOfStockCount = publishedProducts.filter((p) => {
      const stock = Number(p.stock) || 0;
      return stock === 0;
    }).length;

    console.log('Inventory summary calculation:', {
      totalProducts,
      totalStock,
      lowStockCount,
      outOfStockCount,
      publishedProductsCount: publishedProducts.length,
      allProductsCount: products.length,
      sampleProducts: publishedProducts.slice(0, 3).map(p => ({
        id: p._id,
        stock: p.stock,
        title: p.title,
        status: p.status
      }))
    });

    setInventorySummary({
      totalProducts,
      totalStock,
      lowStockCount,
      outOfStockCount,
    });
  };

  // Fetch low stock report
  const fetchLowStockReport = async () => {
    try {
      const res = await api.get("/vendor/low-stock-report");
      if (res.data.success) {
        if (res.data.count === 0) {
          alert("No low stock products found. All products have sufficient stock.");
        } else {
          const productList = res.data.products
            .map(p => `• ${p.title}: ${p.stock} units left`)
            .join('\n');
          alert(`Low Stock Report (Threshold: ${res.data.threshold} units)\n\nFound ${res.data.count} product(s) with low stock:\n\n${productList}`);
        }
      } else {
        alert("Failed to fetch low stock report: " + (res.data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Failed to fetch low stock report:", error);
      alert(`Failed to fetch low stock report. Error: ${error.response?.data?.message || error.message}`);
    }
  };

  // Update inventory summary when products change
  useEffect(() => {
    calculateInventorySummary();
  }, [products]);

  /* ======================
     FILTER ACTIONS
     ====================== */
  // Apply low stock filter
  const applyLowStockFilter = () => {
    setStockFilter("low");
    setPage(0); // Reset to first page when filter changes
  };

  // Apply out of stock filter
  const applyOutOfStockFilter = () => {
    setStockFilter("out");
    setPage(0);
  };

  // Reset all filters
  const resetAllFilters = () => {
    setSearch("");
    setCategoryFilter("");
    setStockFilter("all");
    setStatusFilter("all");
    setFeaturedFilter("all");
    setPage(0);
  };

  // Check if any filter is active
  const isAnyFilterActive = () => {
    return (
      search !== "" ||
      categoryFilter !== "" ||
      stockFilter !== "all" ||
      statusFilter !== "all" ||
      featuredFilter !== "all"
    );
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={700}>
        Vendor Dashboard – Inventory Management
      </Typography>

      {/* FILTER STATUS & RESET */}
      {isAnyFilterActive() && (
        <Paper sx={{ mt: 2, p: 2, bgcolor: "#f5f5f5" }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body2">
              Active filters:
              {search && ` Search: "${search}"`}
              {categoryFilter && ` Category: ${CATEGORY_LIST.find(c => c._id === categoryFilter)?.name || categoryFilter}`}
              {stockFilter !== "all" && ` Stock: ${stockFilter}`}
              {statusFilter !== "all" && ` Status: ${statusFilter}`}
              {featuredFilter !== "all" && ` Featured: ${featuredFilter}`}
            </Typography>
            <Button
              size="small"
              variant="outlined"
              onClick={resetAllFilters}
            >
              Reset All Filters
            </Button>
          </Stack>
        </Paper>
      )}

      {/* INVENTORY SUMMARY CARDS */}
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ bgcolor: "#f0f7ff", borderRadius: 2 }}>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={1}>
                <InventoryIcon sx={{ color: "#1976d2" }} />
                <Typography variant="h6" fontWeight={600}>
                  {inventorySummary.totalProducts}
                </Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary">
                Total Products
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ bgcolor: "#f0fff4", borderRadius: 2 }}>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={1}>
                <CheckIcon sx={{ color: "#2e7d32" }} />
                <Typography variant="h6" fontWeight={600}>
                  {inventorySummary.totalStock}
                </Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary">
                Total Stock
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ bgcolor: "#fff8e1", borderRadius: 2, cursor: "pointer", "&:hover": { boxShadow: 3 } }}
                onClick={applyLowStockFilter}>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={1}>
                <WarningIcon sx={{ color: "#ed6c02" }} />
                <Typography variant="h6" fontWeight={600}>
                  {inventorySummary.lowStockCount}
                </Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary">
                Low Stock (≤10)
              </Typography>
              <Typography variant="caption" color="warning.main" sx={{ display: "block", mt: 0.5 }}>
                Click to filter low stock items
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ bgcolor: "#ffebee", borderRadius: 2, cursor: "pointer", "&:hover": { boxShadow: 3 } }}
                onClick={applyOutOfStockFilter}>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={1}>
                <ErrorIcon sx={{ color: "#d32f2f" }} />
                <Typography variant="h6" fontWeight={600}>
                  {inventorySummary.outOfStockCount}
                </Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary">
                Out of Stock
              </Typography>
              <Typography variant="caption" color="error.main" sx={{ display: "block", mt: 0.5 }}>
                Click to filter out of stock items
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* BULK UPDATE PANEL */}
      {selectedProducts.length > 0 && (
        <Paper sx={{ mt: 3, p: 2, bgcolor: "#e3f2fd" }}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center">
            <Typography variant="subtitle1" fontWeight={600}>
              {selectedProducts.length} product(s) selected
            </Typography>
            <TextField
              size="small"
              label="Set stock to"
              value={bulkStockValue}
              onChange={(e) => setBulkStockValue(e.target.value)}
              sx={{ width: 150 }}
              InputProps={{
                endAdornment: <InputAdornment position="end">units</InputAdornment>,
              }}
            />
            <Button
              variant="contained"
              startIcon={<SaveIcon />}
              onClick={handleBulkStockUpdate}
              disabled={!bulkStockValue}
            >
              Update Stock
            </Button>
            <Button
              variant="outlined"
              startIcon={<CloseIcon />}
              onClick={() => setSelectedProducts([])}
            >
              Clear Selection
            </Button>
          </Stack>
        </Paper>
      )}

      {/* SEARCH / FILTER / ACTIONS */}
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mt={3}>
        <TextField
          label="Search products"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ flex: 1 }}
        />

        <Select
          value={categoryFilter}
          onChange={(e) => setCategoryFilter(e.target.value)}
          displayEmpty
          sx={{ minWidth: 200 }}
        >
          <MenuItem value="">All Categories</MenuItem>
          {CATEGORY_LIST.map((cat) => (
  <MenuItem key={cat._id} value={cat._id}>
    {cat.name}
  </MenuItem>
))}
        </Select>

        <Stack direction="row" spacing={1}>
          <Button
            variant="contained"
            sx={{ background: "#ff9900" }}
            onClick={() => navigate("/vendor/products/new")}
          >
            + Add Product
          </Button>

          <Button
            variant="outlined"
            startIcon={<UploadFileIcon />}
            component="label"
          >
            Upload Excel
            <input
              hidden
              type="file"
              accept=".xls,.xlsx"
              onChange={(e) => {
                const f = e.target.files?.[0];
                if (f) handleBulkUpload(f);
                e.target.value = null;
              }}
            />
          </Button>

          <Button
            variant="outlined"
            color="warning"
            startIcon={<WarningIcon />}
            onClick={fetchLowStockReport}
          >
            Low Stock Report
          </Button>
        </Stack>
      </Stack>

      {/* TABLE */}
      <Paper sx={{ mt: 3, p: isMobile ? 2 : 0 }}>
  {isMobile ? (
    <Stack spacing={2}>
      {paginated.map((p) => (
        <MobileProductCard
          key={p._id}
          product={p}
          onView={() => navigate(`/vendor/product/${p._id}`)}
          onEdit={() => navigate(`/vendor/edit-product/${p._id}`)}
          onDelete={() => {
            setDeleteId(p._id);
            setDeleteOpen(true);
          }}
          onToggleFeatured={handleToggleFeatured}
        />
      ))}

      {filtered.length === 0 && (
        <Typography align="center" sx={{ py: 4 }}>
          No products found
        </Typography>
      )}
    </Stack>
  ) : (
    <>
      {/* SELECT ALL CHECKBOX */}
      {selectedProducts.length > 0 && (
        <Box sx={{ p: 2, bgcolor: "#f5f5f5", borderRadius: 1, mb: 1 }}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="body2">
              {selectedProducts.length} product(s) selected
            </Typography>
            <Button
              size="small"
              variant="outlined"
              onClick={selectAllProducts}
            >
              {selectedProducts.length === filtered.length ? "Deselect All" : "Select All"}
            </Button>
          </Stack>
        </Box>
      )}

      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox">
              <Checkbox
                indeterminate={selectedProducts.length > 0 && selectedProducts.length < filtered.length}
                checked={filtered.length > 0 && selectedProducts.length === filtered.length}
                onChange={selectAllProducts}
              />
            </TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Title</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Category</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>
              <Stack direction="column" spacing={0.5}>
                <span>Featured</span>
                <Select
                  size="small"
                  value={featuredFilter}
                  onChange={(e) => setFeaturedFilter(e.target.value)}
                  sx={{ minWidth: 120, fontSize: '0.75rem', height: 28 }}
                  displayEmpty
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="featured">Featured</MenuItem>
                  <MenuItem value="not-featured">Not Featured</MenuItem>
                </Select>
              </Stack>
            </TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Price</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>
              <Stack direction="column" spacing={0.5}>
                <span>Stock</span>
                <Select
                  size="small"
                  value={stockFilter}
                  onChange={(e) => setStockFilter(e.target.value)}
                  sx={{ minWidth: 120, fontSize: '0.75rem', height: 28 }}
                  displayEmpty
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="low">Low (≤10)</MenuItem>
                  <MenuItem value="out">Out of Stock</MenuItem>
                  <MenuItem value="low+out">Low + Out of Stock</MenuItem>
                  <MenuItem value="sufficient">Sufficient (&gt;10)</MenuItem>
                </Select>
              </Stack>
            </TableCell>
            <TableCell sx={{ fontWeight: 700 }}>
              <Stack direction="column" spacing={0.5}>
                <span>Status</span>
                <Select
                  size="small"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  sx={{ minWidth: 120, fontSize: '0.75rem', height: 28 }}
                  displayEmpty
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="published">Published</MenuItem>
                  <MenuItem value="unlisted">Unlisted</MenuItem>
                  <MenuItem value="draft">Draft</MenuItem>
                </Select>
              </Stack>
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 700 }}>Actions</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {paginated.map((p) => (
            <TableRow key={p._id} hover selected={selectedProducts.includes(p._id)}>
              <TableCell padding="checkbox">
                <Checkbox
                  checked={selectedProducts.includes(p._id)}
                  onChange={() => toggleProductSelection(p._id)}
                />
              </TableCell>
              <TableCell>{p.title}</TableCell>
              <TableCell>{p.category?.name || "-"}</TableCell>
              <TableCell>
                <FormControlLabel
                  control={
                    <Switch
                      checked={p.isFeatured || false}
                      onChange={() => handleToggleFeatured(p._id, !p.isFeatured)}
                      size="small"
                      color="primary"
                    />
                  }
                  label={p.isFeatured ? "Yes" : "No"}
                  labelPlacement="end"
                  sx={{ m: 0 }}
                />
              </TableCell>
              <TableCell>₹{Number(p.price || 0).toLocaleString("en-IN")}</TableCell>
              <TableCell>
                {editingStockId === p._id ? (
                  <Stack direction="row" spacing={1} alignItems="center">
                    <TextField
                      size="small"
                      value={editingStockValue}
                      onChange={(e) => setEditingStockValue(e.target.value)}
                      sx={{ width: 100 }}
                      autoFocus
                    />
                    <IconButton size="small" color="primary" onClick={saveStockEdit}>
                      <CheckIcon />
                    </IconButton>
                    <IconButton size="small" color="error" onClick={cancelStockEdit}>
                      <CloseIcon />
                    </IconButton>
                  </Stack>
                ) : (
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography>
                      {p.stock ?? "-"}
                      {(p.stock || 0) <= 10 && (p.stock || 0) > 0 && (
                        <WarningIcon sx={{ color: "orange", fontSize: 16, ml: 0.5 }} />
                      )}
                      {(p.stock || 0) === 0 && (
                        <ErrorIcon sx={{ color: "red", fontSize: 16, ml: 0.5 }} />
                      )}
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() => startEditStock(p._id, p.stock)}
                      sx={{ color: "#666" }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Stack>
                )}
              </TableCell>
              <TableCell>
                <Chip
                  label={p.status}
                  size="small"
                  color={
                    p.status === "published" ? "success" :
                    p.status === "unlisted" ? "warning" :
                    "default"
                  }
                />
              </TableCell>

              <TableCell align="right">
                {/* <IconButton onClick={() => navigate(`/vendor/product/${p._id}`)}>
                  <VisibilityIcon />
                </IconButton> */}

                <IconButton
                  sx={{ color: "#ff9900" }}
                  onClick={() =>
                    navigate(`/vendor/edit-product/${p._id}`)
                  }
                >
                  <EditIcon />
                </IconButton>

                <IconButton
                  color="error"
                  onClick={() => {
                    setDeleteId(p._id);
                    setDeleteOpen(true);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
  <Tooltip
  title={
    p.status === "published"
      ? "Unlist (Hide from customers)"
      : "Publish (Make visible to customers)"
  }
>
  <IconButton
    onClick={async () => {
      await api.patch(`/products/${p._id}/toggle-visibility`);

      setProducts((prev) =>
        prev.map((prod) =>
          prod._id === p._id
            ? {
                ...prod,
                status:
                  prod.status === "published"
                    ? "unlisted"
                    : "published",
              }
            : prod
        )
      );
    }}
    sx={{
      color:
        p.status === "published"
          ? "orange"
          : "green",
    }}
  >
    {p.status === "published" ? (
      <VisibilityOffIcon />
    ) : (
      <CheckCircleIcon />
    )}
  </IconButton>
</Tooltip>
              </TableCell>
            </TableRow>
          ))}

          {filtered.length === 0 && (
            <TableRow>
              <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                No products found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <TablePagination
        component="div"
        count={filtered.length}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
        onPageChange={(_, newPage) => setPage(newPage)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
      />
    </>
  )}
</Paper>


      {/* DELETE CONFIRM */}
      <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
        <DialogTitle>Delete product?</DialogTitle>
        <DialogContent>
          This action cannot be undone.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteOpen(false)}>Cancel</Button>
          <Button color="error" onClick={confirmDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}